import { useEffect, useRef } from 'react';
import { graphql, fetchQuery, type RelayRefetchProp } from 'react-relay';

import { filterNulls } from 'dibs-ts-utils/exports/filterNulls';
import { type useFetchDesignProjectPhotosQuery as PhotosQuery } from './__generated__/useFetchDesignProjectPhotosQuery.graphql';
import { type Photo } from 'dibs-interiors-photos/exports/types';

const photosQuery = graphql`
    query useFetchDesignProjectPhotosQuery($projectRootId: String!) {
        viewer {
            designProjectRootSearch(projectRootId: $projectRootId) {
                tradePhotos {
                    url
                    serviceId
                    path
                    width
                    height
                    name
                }
            }
        }
    }
`;

type Args = {
    projectRootId: string;
    relay: RelayRefetchProp;
    onFetchComplete: (arg0: Photo[]) => void;
    hasPrefetchedPhotos: boolean;
};

export function useFetchDesignProjectPhotos(args: Args): void {
    const { projectRootId, relay, hasPrefetchedPhotos, onFetchComplete } = args;

    const isFirstRunRef = useRef(true);

    useEffect(() => {
        if (isFirstRunRef.current) {
            isFirstRunRef.current = false;
            if (projectRootId && !hasPrefetchedPhotos) {
                fetchQuery<PhotosQuery>(relay.environment, photosQuery, {
                    projectRootId,
                }).subscribe({
                    next: data => {
                        const tradePhotos = (
                            data?.viewer?.designProjectRootSearch?.tradePhotos || []
                        ).filter(filterNulls);
                        onFetchComplete(tradePhotos);
                    },
                });
            }
        }
    }, [projectRootId, relay, hasPrefetchedPhotos, onFetchComplete]);
}
